import { render, staticRenderFns } from "./ActivitiesForm.vue?vue&type=template&id=e8c02d4c&lang=pug&"
import script from "./ActivitiesForm.vue?vue&type=script&setup=true&lang=js&"
export * from "./ActivitiesForm.vue?vue&type=script&setup=true&lang=js&"
import style0 from "./ActivitiesForm.vue?vue&type=style&index=0&id=e8c02d4c&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports